import { SxProps, Theme } from '@mui/material';
import { WarningAmber } from '@mui/icons-material';

type Props = {
  color?: string;
  size?: number;
};

const iconSx = (size: number, color: string): SxProps<Theme> => ({
  fontSize: `${size}px`,
  color
});

export const ReviewIcon: React.FC<Props> = ({
  color = 'warningV2.dark',
  size = 20
}) => <WarningAmber sx={iconSx(size, color)} />;
